<template>
	<div class="flex flex-col gap-4 px-6 pb-6 font-[Inter]">
		<div class="flex flex-col gap-2">
			<div class="flex flex-col gap-2 text-center">
				<h2 class="text-xl leading-7 font-semibold text-[#111827]">
					Upload your resume to get started
				</h2>
				<p class="text-sm leading-5 text-[#6B7280]">
					AutoApply needs your resume to prepare tailored applications. Upload it now and you'll be ready to apply
					in minutes.
				</p>
			</div>

			<ResumeDropzone
				input-id="auto-apply-promo-resume-file"
				class="min-h-64"
				:is-uploading="isUploading"
				:progress="progress"
				:file-name="fileName"
				:has-file="!!result"
				:has-error="!!error"
				@select="uploadFile"
			/>

			<p
				v-if="error"
				role="alert"
				class="text-center text-sm text-red-600"
			>
				{{ error }}
			</p>

			<p class="text-center text-xs leading-4 text-[#6B7280]">
				Your resume is processed securely, used only to build your profile and power your applications, and never
				shared with advertisers.
				<a
					href="https://www.wonsulting.com/privacy-policy"
					target="_blank"
					rel="noopener"
					class="underline hover:opacity-80"
				>
					Privacy Policy
				</a>
			</p>
		</div>

		<p class="text-center text-sm leading-5 text-[#111827]">
			No resume?
			<button
				type="button"
				class="cursor-pointer font-medium text-won-green underline hover:opacity-80"
				@click="store.showLinkedInInstructions"
			>
				Get it from LinkedIn
			</button>
			or
			<button
				type="button"
				class="cursor-pointer font-medium text-won-green underline hover:opacity-80"
				@click="createWithResumAI"
			>
				Create New with Resume AI
			</button>
		</p>
	</div>
</template>

<script setup>
import { watch } from 'vue';
import { useRouter } from 'vue-router';

import ResumeDropzone from '../../../components/resume-dropzone.vue';
import { uploadAutoApplyPromoResume } from '../../../api/auto-apply-promo';
import { useOnboardingResumeUpload } from '../../../composables/useOnboardingResumeUpload';
import { useAutoApplyPromoStore } from '../../../store/auto-apply-promo.store';

const router = useRouter();
const store = useAutoApplyPromoStore();

const { isUploading, progress, error, result, fileName, uploadFile } =
	useOnboardingResumeUpload({ upload: uploadAutoApplyPromoResume });

// Unlike onboarding there is no Continue button: a landed upload moves straight on.
watch(result, (resume) => {
	if (resume) {
		store.resumeUploaded(resume);
	}
});

// Leaving for the builder counts as a Remind Me Later; the new resume becomes primary there.
const createWithResumAI = () => {
	router.push({ name: 'resumes.edit', query: { set_primary: 'true' } });
	store.closeGate();
};
</script>
